
import AppModal from "./modal.vue";
import Vue from 'vue';

const Modal = {
  install(Vue, options) {
    this.EventBus = new Vue();

    Vue.component("app-modal", AppModal);
    Vue.prototype.$modal = {
      show(params) {
        Modal.EventBus.$emit("show", params);
      }
    };
  }
};

Vue.use(Modal);

export default Modal;